import module from '../components/NotificationModal/store/notificationModal';
export default {
    install(Vue) {
        if (!Vue.$store.state['NotificationModal']) {
            Vue.$store.registerModule('NotificationModal', module);
        }
    }
};
